import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	box: [],
}

export const boxSlice = createSlice({
	name: 'box',
	initialState,
	reducers: {
		addBox: (state, action) => {
			state.box = action.payload
		},
		deleteBox: (state, action) => {
			state.box.filter(user => action.payload.id != user.id)
		},
		updateBox: (state, action) => {
			state.box.map(user => {
				if (user.id == action.payload.id) return action.payload
				return user
			})
		},
	},
})

// Action creators are generated for each case reducer function
export const { addBox, deleteBox } = boxSlice.actions

export default boxSlice.reducer